import mayank from "./assets/mayank.png";
import priyanshu from "./assets/priyanshu.jpeg"
import ali from "./assets/ali.png"
import zaid from "./assets/zaid.png"
import manthan from "./assets/manthan.png"
import hamza from "./assets/hamza.png"
import kajal from "./assets/kajal.png"
import shivdat from "./assets/shivdat.png"
import mandakini from "./assets/mandakini.png"
import Aanchal from "./assets/aanchal.png"
import john from "./assets/john.png"
import helee from "./assets/helee.png"
import vedika from "./assets/vedika.png"
import divya from "./assets/divya.png"
import depika from "./assets/depika.png"
import sanika from "./assets/sanika.png"
import janvi from "./assets/janvi.png"
import rachit from "./assets/rachit.png"
import hemant from "./assets/hemant.png"
import akash from "./assets/akash.png"
import durgesh from "./assets/durgesh.png"
import manjiri from "./assets/manjiri.png"
import gautam from "./assets/gautam.png"




export const courses = [
  {
    icon: "📘",
    title: "School Batches",
    details: "I - VIII, IX & X",
    sub: "SSC / CBSE / ICSE Board",
  },
{
  icon: "💼",
  title: "Commerce",
  details: "XI & XII",
  sub: (
    <>
      F.Y., S.Y., T.Y. B.Com, B.A.F, B.M.S,
      <br />
      M.Com, CA
    </>
  ),
},
  {
    icon: "🔬",
    title: "Science",
    details: "XI & XII",
    sub: "NEET / MHT-CET",
  },
  {
    icon: "🎥",
    title: "VCR / Regular Batches",
    details: "Starting From April / June 2026",
    sub: "Free Demo Lecture Available",
  },
];

export const whyJoin = [
  "100% Guaranteed Result",
  "Affordable Fees",
  "Student Friendly Teaching",
  "Monthly Test / Orals",
  "Well Equipped Infrastructure",
  "100% Scholarship & Job Assistance",
];

export const hscToppers = [
  { name: "Hamzah Qureshi", score: "92.33%", college: "National College" ,image: hamza},
  { name: "Momin Mehboob Ali", score: "84%", college: "Elphinstone College",image: ali },
  { name: "Kajal Rai", score: "82.67%", college: "Elphinstone College",image: kajal },
  { name: "Priyanshu Thakur", score: "82%", college: "Elphinstone College",image: priyanshu },
  { name: "Mohd Zaid Rain", score: "81.33%", college: "Bhavans College" ,image: zaid},
  { name: "Manthan Palekar", score: "81.33%", college: "Elphinstone College",image: manthan},
  { name: "Mayank Gupta",score: "80%",college: "Wilson College",image: mayank},
];

export const sscToppers = [
  { name: "Shivdat Gautam", score: "94%", college: "St. Teresa’s School",image: shivdat },
  { name: "Mandakini Pandey", score: "93%", college: "Blossom High School" ,image: mandakini},
  { name: "Aanchal Tripathi", score: "90%", college: "St. Xavier’s High School",image: Aanchal },
  { name: "John Sylvia", score: "84%", college: "St. Joseph High School",image: john },
  { name: "Helee Bhatkar", score: "79%", college: "St. Joseph High School" ,image: helee},
  { name: "Divya Rathod", score: "77%", college: "Holyname School",image: divya },
  { name: "Vedika Handgavskar", score: "77%", college: "Holyname School",image: vedika},
  { name: "Sanika Jadhav", score: "75%", college: "St. Joseph High School" ,image: sanika},
  { name: "Jaanvi Pandey", score: "75%", college: "St. Joseph High School",image: janvi },
  { name: "Deepika Bangre", score: "74%", college: "St. Joseph High School",image: depika },
];

export const degreeToppers = [
  { name: "Gautam Rajodia", score: "Grade O", college: "Vidyalankar College" ,image: gautam},
  { name: "Rachit Nakte", score: "Grade O", college: "Siddhart College" ,image: rachit },
  { name: "Hemant Gupta", score: "Grade O", college: "Siddhart College" ,image: hemant},
  { name: "Aakash Gupta", score: "Grade O", college: "Siddhart College" ,image: akash},
  { name: "Durgesh Shelar", score: "Grade O", college: "Siddham College" ,image: durgesh},
  { name: "Manjiri Katkar", score: "Grade O", college: "Sydenham College" ,image: manjiri},
];


